"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.definePooledObjectStore = definePooledObjectStore;

var _LazyKeyStore = require("../store/LazyKeyStore");

function idIsValid(id) {
  return typeof id === 'string' || typeof id === 'number';
}

function idTransform(id) {
  return "" + id;
}

function definePooledObjectStore(_ref) {
  var actionTypePrefix = _ref.actionTypePrefix;
  return (0, _LazyKeyStore.defineLazyKeyStore)({
    namespace: actionTypePrefix,
    idIsValid: idIsValid,
    idTransform: idTransform
  });
}